import React from "react";
import SearchField from "components/search-field";
import wallet from "assets/icons/wallet-dark.svg";
import plusAdd from "assets/icons/add-circle.svg";
import bell from "assets/icons/bell.svg";
import dummy from "assets/images/user.png";
import { useHeader, useWallet } from "hooks";
import userIcon from "assets/icons/user.svg";
import settings from "assets/icons/settings.svg";
import supportCircle from "assets/icons/help-circle.svg";
import logout from "assets/icons/log-out.svg";
import { currencyFormatter } from "utils/random";

export default function DesktopHeader() {
  const {
    user,
    handleHeaderMenuToggle,
    isHeaderMenuOpen,
    handleLogout,
    handleNavigate,
  } = useHeader();

  // const { walletData, currencyFormatter } = useWallet();

  return (
    <header className="h-[84px] w-full flex justify-between items-center px-9 shadow-[0px_4px_40px_0px_rgba(0,_0,_0,_0.15)]">
      <div className="w-1/3 h-[80%]">
        <SearchField border={false} />
      </div>
      <div className="w-1/3 h-[90%] flex justify-end gap-20 items-center relative">
        <div className="flex gap-6 items-center">
          <div className="flex gap-4">
            <img src={wallet} alt="" />
            <div className="">
              <span className="text-xs leading-[17.4px] text-[#475467]">
                wallet Bal.
              </span>
              <h2 className="text-[#344054] font-semibold leading-[20.3px]">
                {/* {currencyFormatter().format(Number(walletData?.balance))} */}
              </h2>
            </div>
          </div>
          <div className="">
            <img src={plusAdd} alt="" />
          </div>
        </div>
        <div className="flex gap-2">
          <div className="h-[40px] w-[40px] flex justify-center items-center bg-[#F0F2F5] rounded-full">
            <img src={bell} alt="" className="h-[18px] w-[18px]" />
          </div>
          <img
            src={user?.profilePic ?? dummy}
            alt={user?.firstname}
            title={user?.firstname}
            className="h-[40px] w-[40px] object-cover cursor-pointer rounded-full"
            onClick={handleHeaderMenuToggle}
          />
        </div>
        {isHeaderMenuOpen && (
          <div className="absolute top-14 flex flex-col border border-[#F2F4F7] shadow-[0px_4px_40px_0px_rgba(0,_0,_0,_0.15)] bg-white z-20">
            <div className="">
              <div className="flex gap-3 items-center p-[12px_16px] border-b border-[#F2F4F7]">
                <img
                  src={user?.profilePic ?? dummy}
                  alt={user?.firstname}
                  className="h-[40px] w-[40px] object-cover"
                />
                <div className="flex flex-col gap-2">
                  <h1 className="text-[#101928] text-sm font-medium">
                    {user?.firstname} {user?.surname}
                  </h1>
                  <p className="text-[#475467] text-xs">
                    {user?.email ?? user?.inoId}
                  </p>
                </div>
              </div>
              <div className="flex flex-col p-[12px_16px]">
                <button
                  onClick={() => handleNavigate("/")}
                  className="flex items-center gap-2 p-[10px_16px]"
                >
                  <img
                    src={user?.profilePic ?? userIcon}
                    alt={user?.firstname}
                    className="h-[14px] w-[14px] object-cover"
                  />
                  <span className="text-sm font-medium text-[#344054]">
                    View profile
                  </span>
                </button>
                <button
                  onClick={() => handleNavigate("/settings")}
                  className="flex items-center gap-2 p-[10px_16px]"
                >
                  <img
                    src={settings}
                    alt={"Settings"}
                    className="h-[14px] w-[14px] object-cover"
                  />
                  <span className="text-sm font-medium text-[#344054]">
                    Settings
                  </span>
                </button>
                <button
                  onClick={() => handleNavigate("/help-center")}
                  className="flex items-center gap-2 p-[10px_16px]"
                >
                  <img
                    src={supportCircle}
                    alt={"Support"}
                    className="h-[14px] w-[14px] object-cover"
                  />
                  <span className="text-sm font-medium text-[#344054]">
                    Support
                  </span>
                </button>
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-2 p-[10px_16px]"
                >
                  <img
                    src={logout}
                    alt={"log out"}
                    className="h-[14px] w-[14px] object-cover"
                  />
                  <span className="text-sm font-medium text-[#344054]">
                    Log out
                  </span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
